import { render, staticRenderFns } from "./ProductTypeButtons.vue?vue&type=template&id=ff1d7af8&scoped=true&"
import script from "./ProductTypeButtons.vue?vue&type=script&lang=js&"
export * from "./ProductTypeButtons.vue?vue&type=script&lang=js&"
import style0 from "./ProductTypeButtons.vue?vue&type=style&index=0&id=ff1d7af8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1d7af8",
  null
  
)

export default component.exports